import React from "react";
import { View } from "react-native";
import { useMedicalHistoryTheme } from "../theme/MedicalHistoryTheme";
import { LoadingState } from "@louise/moon-ui";

export function MedicalHistoryLoadingScreen() {
  const theme = useMedicalHistoryTheme();

  return (
    <View
      testID="screen-loading"
      style={{
        flex: 1,
        backgroundColor: theme.screenBg,
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <LoadingState />
    </View>
  );
}
